module.exports = __webpack_public_path__ + "img/penalty_list.a268d492.png";